<template>
  <div class="agreement-popup" v-if="config.privacy_agreement">
    <div class="content">
      <div class="title">{{ $t('web_tips_title') }}</div>
      <i18n path="text_agreement" tag="div" class="text">
        <slot name="0">123</slot>
        <slot name="1">
          <span class="link" @click="jumpUrl('privacy')">{{ $t('link_privacy') }}</span>
        </slot>
        <slot name="2">
          <span class="link" @click="jumpUrl('agreement')">{{ $t('link_agreement') }}</span>
        </slot>
      </i18n>
      <div class="button btn" @click="agree">{{ $t('text_btn_agree') }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AgreementPopup',
  props: ['country'],
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: 'config'
    })
  },
  methods: {
    jumpUrl (type) {
      let url = ''
      if (type === 'privacy') {
        url = this.config.privacy_agreement
      } else {
        url = this.config.user_agreement
      }
      if (this.country === 'TW') {
        if (type === 'privacy') {
          url = 'https://privacy.sosgame.tw/privacy-policy.html'
        } else {
          url = 'https://privacy.sosgame.tw/terms-conditions.html'
        }
      }
      window.open(url, '__blank')
    },
    agree () {
      this.$bus.$emit('agreement-click')
    }
  }
}
</script>

<style lang='scss' scoped >
.agreement-popup {
  z-index: 10000;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  width: 660px;
  padding: 30px;
  background-color: rgba(56, 56, 56, 1);
  border-radius: 18px;
  color: white;
}
.title {
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 33px;
  padding: 0;
}
.text {
  margin-top: 20px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 25px;
  letter-spacing: 1px;
  span {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF5E0F;
    cursor: pointer;
    text-decoration: underline;
  }
}
.button {
  width: 200px;
  background-color: rgba(255, 94, 15, 1);
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 50px;
  margin: 20px auto 0;
}
</style>
